module.exports = "/_next/static/images/step2Illustration-4d0ddaef8f625b5882ad1fe087eeea5b.svg";